module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"total_package_weight":"Total package weight"},"id":{"total_package_weight":"Total berat paket"}}')
  delete Component.options._Ctor
}
